import { useEffect, useRef } from 'react';
import { useChannelActionContext, useChannelStateContext } from 'stream-chat-react';

export const AutoScrollToUnread: React.FC = () => {
  const { jumpToFirstUnreadMessage } = useChannelActionContext();
  const { channel, messages } = useChannelStateContext();
  const scrollListenerRef = useRef<() => void | null>(null);

  useEffect(() => {
    if (!channel) return;

    // Check if there are unread messages. If so, scroll to the first unread message and mark the channel as read.
    const unreadCount = channel.countUnread();
    const handleInitialUnread = async () => {
      if (unreadCount > 0) {
        await jumpToFirstUnreadMessage(100);
        // Slight delay to give DOM time to paint unread marker
        setTimeout(() => {
          channel.markRead();
        }, 250);
      }
    };

    handleInitialUnread();

    // Scroll listener
    const messageListEl = document.querySelector('.str-chat__list');
    if (!messageListEl) return;

    // Mark the channel as read when scrolled to the bottom
    const handleScroll = () => {
      if (
        messageListEl.scrollHeight - messageListEl.scrollTop <=
        messageListEl.clientHeight + 20 // ~20px tolerance
      ) {
        channel.markRead();
      }
    };

    messageListEl.addEventListener('scroll', handleScroll);
    scrollListenerRef.current = handleScroll;

    return () => {
      if (scrollListenerRef.current && messageListEl) {
        messageListEl.removeEventListener('scroll', scrollListenerRef.current);
      }
    };
  }, [channel, jumpToFirstUnreadMessage, messages?.length]);

  return null;
};
